/**
 * Stundenformatierung für das Überstundenkonto. Eigene Datei, damit die Komponenten
 * ausschließlich Komponenten exportieren (Fast Refresh).
 */

/**
 * Stunden mit Vorzeichen: `+12,50 h` / `−3,25 h`, Halbgeviert-Minus und Komma als
 * Dezimaltrenner (Design-Guidelines §9).
 */
export function formatSignedHours(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  const formatted = Math.abs(rounded).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (rounded > 0) return `+${formatted} h`;
  if (rounded < 0) return `−${formatted} h`;
  return `${formatted} h`;
}

/** Stunden ohne Vorzeichen — für Teilbeträge, bei denen die Richtung aus dem Label kommt. */
export function formatHours(value: number): string {
  return `${value.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} h`;
}

/** ISO-Datum als `MM.YYYY` — der Zeitraum ist monatsgenau, der Tag wäre irreführend. */
export function formatMonthYear(isoDate: string): string {
  if (!isoDate) return '';
  return new Date(isoDate).toLocaleDateString('de-DE', { month: '2-digit', year: 'numeric' });
}

/** ISO-Datum als `DD.MM.YYYY` — für den Stichtag, der taggenau zählt. */
export function formatDay(isoDate: string): string {
  if (!isoDate) return '';
  return new Date(isoDate).toLocaleDateString('de-DE');
}
